export default "__VITE_ASSET__BHt4xxzy__"